<div class="receipt-page">
  <div class="receipt-sheet">
    <!-- Loading -->
    <div class="receipt-loading" *ngIf="step() === 'loading'" role="status" aria-live="polite">
      <span class="receipt-spinner" aria-hidden="true"></span>
      <p class="receipt-loading-text">Loading your receipt…</p>
    </div>

    <!-- Receipt -->
    <div class="receipt-card" *ngIf="step() === 'ready' && receipt() as r">
      <header class="receipt-brand">
        <img
          *ngIf="logoUrl()"
          class="receipt-logo"
          [src]="logoUrl()"
          [alt]="r.shopName ? r.shopName + ' logo' : 'Shop logo'"
          (error)="onLogoError()"
        />
        <div class="receipt-brand-copy">
          <h1 class="receipt-shop-name" *ngIf="r.shopName">{{ r.shopName }}</h1>
          <p class="receipt-branch" *ngIf="r.branch">{{ r.branch }}</p>
        </div>
      </header>

      <div class="receipt-amount-block">
        <p class="receipt-amount-label">Amount paid</p>
        <p class="receipt-amount" *ngIf="r.amountPaid">{{ r.amountPaid }}</p>
        <span class="receipt-refunded-badge" *ngIf="r.refunded">Refunded</span>
      </div>

      <dl class="receipt-details">
        <div class="receipt-row" *ngIf="r.packageName">
          <dt class="receipt-row-label">Package</dt>
          <dd class="receipt-row-value">{{ r.packageName }}</dd>
        </div>
        <div class="receipt-row" *ngIf="r.washType">
          <dt class="receipt-row-label">Wash type</dt>
          <dd class="receipt-row-value">{{ washTypeLabel(r.washType) }}</dd>
        </div>
        <div class="receipt-row" *ngIf="r.orderNumber">
          <dt class="receipt-row-label">Order number</dt>
          <dd class="receipt-row-value">{{ r.orderNumber }}</dd>
        </div>
        <div class="receipt-row" *ngIf="r.paidAt">
          <dt class="receipt-row-label">Paid at</dt>
          <dd class="receipt-row-value">{{ r.paidAt }}</dd>
        </div>
        <div class="receipt-row" *ngIf="r.paymentMethod">
          <dt class="receipt-row-label">Payment method</dt>
          <dd class="receipt-row-value">{{ r.paymentMethod }}</dd>
        </div>
        <div class="receipt-row" *ngIf="r.refunded && r.refundedAmount">
          <dt class="receipt-row-label">Amount refunded</dt>
          <dd class="receipt-row-value">{{ r.refundedAmount }}</dd>
        </div>
        <div class="receipt-row" *ngIf="r.locationAddress">
          <dt class="receipt-row-label">Location</dt>
          <dd class="receipt-row-value">{{ r.locationAddress }}</dd>
        </div>
      </dl>

      <p class="receipt-footnote">Thank you for your visit!</p>
    </div>

    <!-- Error -->
    <div class="state-block" *ngIf="step() === 'error'">
      <h2 class="state-headline">Receipt unavailable</h2>
      <p class="state-body" role="alert">{{ errorMessage() }}</p>
    </div>
  </div>
</div>
